const serviceOrigin = 'test' === 'production'
  ? 'https://cn.siswe.com'
  : 'test' === 'test'
    ? 'https://siswe.com'
    : 'https://dev.siswe.com'

export const externalServiceUrls = {
  aiCam: `${serviceOrigin}/ai-cam`,
  docs: `${serviceOrigin}/docs`,
  model: `${serviceOrigin}/chat`,
} as const
